import React, { useState } from "react";
import Dropdown from "../Dropdown/Dropdown";
import { dropdownItem } from "../Dropdown/types";

export const pagerOptions = [
  { label: "5", value: 5 },
  { label: "10", value: 10 }
];

export const Module = ({
  pagerFlag = true,
  pagerHandler
}: {
  pagerFlag?: boolean;
  pagerHandler: (dropdown: dropdownItem) => void;
}) => {
  const [pager, updatePager] = useState(pagerOptions[0]);

  const handlePager = (dd: dropdownItem) => {
    pagerHandler(dd);
    updatePager(pagerOptions.filter(op => op.value == dd.value)[0]);
  };

  return (
    <div className="pager">
      <span className="pager__tablet-text">Showing</span>
      <Dropdown
        placeholder={pager.label}
        options={pagerOptions}
        value={
          pagerOptions.filter((op: dropdownItem) => op.value == pager.value)[0]
        }
        onChange={handlePager}
      />
      {pagerFlag ? <span className="per-page-text">items per page</span> : null}
    </div>
  );
};

export default Module;
